import type { ReactNode } from "react";
import type { SetupDetails } from "../types/paymentMethodTypes";
import { CardSetupHero } from "./CardSetupHero";

/** Customer-facing shell for saving a card or paying through a secure link. */
export function CardSetupLayout({ details, title, description, showCard, purpose = "save_card", children }: {
  details?: Pick<SetupDetails, "businessName" | "customerName">; title?: string; showCard?: boolean;
  purpose?: "save_card" | "payment"; description?: string; children: ReactNode;
}) {
  return (
    <div className="flex-1 bg-background pb-[env(safe-area-inset-bottom)] lg:grid lg:grid-cols-[minmax(340px,420px)_1fr]">
      <CardSetupHero details={details} title={title} description={description} showCard={showCard} purpose={purpose} />
      <main className="mx-auto w-full max-w-md space-y-4 px-5 pb-8 pt-5 lg:max-w-lg lg:self-center lg:px-10 lg:py-12">
        {children}
      </main>
    </div>
  );
}
